import { Snippet } from '#components/patterns/code/snippet/Snippet.tsx';
import type { HostNoun } from '#dn-types/host.ts';
import type { EnrollmentState } from '../types.ts';
import { dockerRunCommand } from './container-install.ts';
import { TokenStatus } from './token-instructions/TokenStatus.tsx';

type Props = {
  url?: string;
  hostNoun: HostNoun;
  enrollmentState: EnrollmentState;
};

export function DockerInstructions({ url, enrollmentState, hostNoun }: Props) {
  return (
    <>
      <h2 className="h3">3. Pull docker image</h2>
      {url ?
        <p className="p-md mb-24">
          Learn more on{' '}
          <a className="a" href={url}>
            Docker Hub
          </a>
        </p>
      : null}
      <Snippet className="mb-40" breakWord={true} addPrompt={true}>
        docker pull definednet/dnclient
      </Snippet>

      <h2 className="h3">4. Run dnclient image</h2>
      <Snippet disabled={!enrollmentState.token || enrollmentState.isExpired} breakWord={true}>
        {dockerRunCommand(enrollmentState.token)}
      </Snippet>
      <TokenStatus
        hostNoun={hostNoun}
        enrollSuccessful={enrollmentState.enrollSuccessful}
        handleDone={enrollmentState.handleDone}
      />
    </>
  );
}
